import { Box, Stack } from "@mui/material";
import i18n from "i18n";

import ResearchTransactionDetail from "components/container-processing/research-transaction-detail/ResearchTransactionDetail";
import { PageTitle } from "components/shared";

const ContainerResearchTransactionDetail = () => {
  return (
    <>
      <Stack>
        <Box>
          <PageTitle
            title={i18n.t("containerResearchTranactionDetail.title")}
          />
        </Box>
        <ResearchTransactionDetail />
      </Stack>
    </>
  );
};
export default ContainerResearchTransactionDetail;
